import { inject, injectable } from "inversify";
import { GuidSelectModel, ICPLUsersSupervisorsClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IUsersSupervisorsService {
  getSubordinateSelectModels(): Promise<GuidSelectModel[]>;
}

@injectable()
export class UsersSupervisorsService implements IUsersSupervisorsService {
  @inject(SERVICE_TYPES.CPLUsersSupervisorsClient)
  cplUsersSupervisorsClient!: ICPLUsersSupervisorsClient;

  async getSubordinateSelectModels(): Promise<GuidSelectModel[]> {
    return this.cplUsersSupervisorsClient.getSubordinateUserSelectModels();
  }
}
